/**
 * Detects if the current device is running iOS (iPhone, iPad, iPod)
 * Works for both Safari and WebView environments
 * @returns {boolean} - true if running on iOS
 */
export function isIOS() {
  try {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIOSDevice = /iphone|ipad|ipod/.test(userAgent);

    // Additional check for iOS 13+ on iPad which reports as Mac in userAgent
    const isMacLikeWithTouch =
      /macintosh/.test(userAgent) &&
      "ontouchend" in document;

    return isIOSDevice || isMacLikeWithTouch;
  } catch (e) {
    return false;
  }
}
